import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useTheme } from '../../context/ThemeContext';
import { Outlet } from 'react-router-dom';
interface LayoutProps {
  children?: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const {
    theme
  } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return <div className={`flex h-screen w-full bg-slate-50 ${theme === 'dark' ? 'dark bg-slate-950 text-slate-50' : 'text-slate-900'} font-sans antialiased selection:bg-accent-500/30`} data-id="element-416">
      <Sidebar isOpen={sidebarOpen} data-id="element-417" />
      <div className="flex flex-col flex-1 overflow-hidden relative" data-id="element-418">
        <Header toggleSidebar={toggleSidebar} data-id="element-419" />
        <main className="flex-1 overflow-y-auto p-4 md:p-8 scroll-smooth" data-id="element-420">
          <div className="max-w-[1600px] mx-auto" data-id="element-421">{children || <Outlet data-id="element-422" />}</div>
        </main>
      </div>
    </div>;
};
export default Layout;